import request from '@/utils/request'

// 登录
export function login(data) {
    return request({
        url: '/api/purchase/login',
        method: 'post',
        data: data
    })
}

// 注册
export function register(data) {
    return request({
        url: '/api/purchase/register',
        method: 'post',
        data: data
    })
}

// 退出登录
export function logout() {
    return request({
        url: '/api/purchase/logout',
        method: 'delete',
    })
}

// 修改密码
export function updateUserPwd(data) {
    return request({
        url: '/api/purchase/updateUserPwd',
        method: 'put',
        data: data
    })
}

// 获取用户信息
export function getUserInfo(query) {
    return request({
        url: '/api/purchase/getUserInfo',
        method: 'get',
        params: query
    })
}

// 修改用户手机号码
export function updatePhoneNumber(data) {
    return request({
        url: '/api/purchase/updatePhoneNumber',
        method: 'post',
        data: data
    })
}

// 绑定
export function bind(data) {
    return request({
        url: '/api/purchase/bind',
        method: 'post',
        data: data
    })
}

// 绑定
export function unbind(data) {
    return request({
        url: '/api/purchase/unbind',
        method: 'post',
        data: data
    })
}

// 获取公众号绑定用户信息
export function getGzhBindUser(query) {
    return request({
        url: '/api/purchase/getGzhBindUser',
        method: 'get',
        params: query
    })
}

// 校验手机号码是否对应该身份证号
export function checkUserPhone(data) {
    return request({
        url: '/api/purchase/checkUserPhone',
        method: 'post',
        data: data
    })
}

// 重置密码
export function resetUserPwd(data) {
    return request({
        url: '/api/purchase/resetUserPwd',
        method: 'post',
        data: data
    })
}